import '../styles/main.scss'

import 'init'
import BackofficeApplication from 'app'

const app = new BackofficeApplication({region:'#container'})
app.start()
